module.exports = __webpack_public_path__ + "img/Manzana-temporada.c2ac371e.jpg";